<template>
    <b-form-group
            :id="name"
            :label="label"
            :label-for="name">
        <datepicker :value="dateValue" :id="name"
                    :name="name" @selected="updateField"></datepicker>
    </b-form-group>
</template>

<script>

    import Datepicker from 'vuejs-datepicker';

    export default {
        name: 'TextInput',
        components: {
            Datepicker
        },
        props: ['placeholder', 'label', 'name', 'value'],
        data() {
            return {
                dateValue: this.value ? this.value : null
            };
        },
        methods: {
            updateField: function (currentState) {
                this.$emit('input', currentState);
            }
        },
        watch: {
            value: function (newValue) {
                this.dateValue = newValue;
            }
        },
    }

</script>